module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAjCAMAAABB9MFTAAAAYFBMVEUAAABWVlZmZmZmZmZmZmZkZGRmZmZmZmZmZmZlZWVmZmZiYmJmZmZlZWVmZmZmZmZmZmZkZGRmZmZhYWFmZmZlZWVnZ2dkZGRmZmZlZWVlZWVmZmZlZWVlZWVoaGhmZmZjSi0JAAAAH3RSTlMACOxi14MVCvTgTB3ymd+V2U4cF8xrXFCfj4Z9uysgXb3ZJgAAAIdJREFUKM+N0EcWhCAQBNBmgjJBMRDM3P+Woju68AnL/5qqBmJHOGU5fV9SA/n/ACTVBlT9boiQhAvxbMo1mJVD1IYs1d2QaBukcwl4torjbbg4xvG0eK/XmMjU/jEXsZXPgO+e/e2JRRZ+MrE8cOoBcTKNyXZbY2a6/RLn1EojQbvUxNEMZgfGugtC3EKYEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swiperToLeftIcon.png
// module id = 06+p
// module chunks = 2